export default __webpack_public_path__ + "static/media/unknown.8e726f60.png";